module.exports = __webpack_public_path__ + "static/media/img3.97d41c08.jpg";